// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import Swiper from 'swiper';
import Headroom from 'headroom.js';
import 'slick-carousel/slick/slick';

require('lightgallery.js');
require('lg-fullscreen.js');
require('lg-thumbnail.js');
require('lg-pager.js');
require('lg-zoom.js');
require('lg-autoplay.js');
require('lg-share.js');
require('lg-video.js');
require('lg-hash.js');
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
//import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
//library.add(faFacebook, faTwitter);
//import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

// Add all icons to the library so you can use it in your page
library.add(fas, far, fab)

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// grab an element
var myElement = document.querySelector('.banner');
// construct an instance of Headroom, passing the element
var options = {
  // vertical offset in px before element is first unpinned
  //offset : 0,
  // or you can specify offset individually for up/down scroll
  offset: {
      up: 0,
      down: 170,
  },
  // scroll tolerance in px before state changes
 // tolerance : 0,
  // or you can specify tolerance individually for up/down scroll
  tolerance : {
      up : 5,
      down : 10,
  },
  // css classes to apply
  classes : {
      // when element is initialised
      initial : 'headroom',
      // when scrolling up
      pinned : 'headroom--pinned',
      // when scrolling down
      unpinned : 'headroom--unpinned',
      // when above offset
      top : 'headroom--top',
//       // when below offset
      notTop : 'headroom--not-top',
//       // when at bottom of scroll area
      bottom : 'headroom--bottom',
//       // when not at bottom of scroll area
      notBottom : 'headroom--not-bottom',
//       // when frozen method has been called
      frozen: 'headroom--frozen',
//       // multiple classes are also supported with a space-separated list
     // pinned: 'headroom--pinned foo bar',
  },
//   // element to listen to scroll events on, defaults to `window`
  //scroller : someElement,
  // callback when pinned, `this` is headroom object
  onPin : function() {},
//   // callback when unpinned, `this` is headroom object
  onUnpin : function() {},
//   // callback when above offset, `this` is headroom object
  onTop : function() {},
//   // callback when below offset, `this` is headroom object
  onNotTop : function() {},
//   // callback when at bottom of page, `this` is headroom object
  onBottom : function() {},
//   // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom : function() {},
};
// pass options as the second argument to the constructor
// supplied options are merged with defaults
var headroom = new Headroom(myElement, options);

// initialise
headroom.init(); 



//initializa swiper js
jQuery(document).ready(function(){
  new Swiper();
  $(document).ready(function() {
  $('.lightgallery').lightGallery(); 
});

    
var btn = $('#button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});




});

jQuery(function($){
  //console.log('called before prod-categories');
  $('.tp_products').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  mobileFirst:true,
  arrows: true,
  lazyLoad: 'progressive',
  //prevArrow:'<button type="button" class="slick-prev pull-left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
 // nextArrow:'<button type="button" class="slick-next pull-right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
  dots: false,
  //variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 4,
      },
      },
    {
      breakpoint: 768,
      settings: {
      arrows: true,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2,
      },
      },
    {
      breakpoint: 480,
      settings: {
      arrows: false,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      },
    },
    {
      breakpoint: 240,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
      },
    ],
  });

  $('.feature_posts').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    mobileFirst:true,
    arrows: true,
    lazyLoad: 'progressive',
    // prevArrow: true,
    // nextArrow: true,
    dots: false,
    //variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
        },
        },
      {
        breakpoint: 768,
        settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2,
        },
        },
      {
        breakpoint: 480,
        settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        },
      },
      {
        breakpoint: 240,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
        },
      ],
    });

    $('.top-selling-products .row-products').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      mobileFirst:true,
      arrows: true,
      lazyLoad: 'progressive',
      //prevArrow:'<button type="button" class="slick-prev pull-left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      //nextArrow:'<button type="button" class="slick-next pull-right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      dots: false,
      // variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 4,
          },
          },
        {
          breakpoint: 768,
          settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2,
          },
          },
        {
          breakpoint: 480,
          settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          },
        },
        {
          breakpoint: 240,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
          },
        ],
      });
      // end of top_selling_products
      
    $('.show_more_btn').on('click',function(){
      if($('.product_categories').find( '.hide' ).length>0){
        $('.product_categories').find('.hide').addClass('show');
        $('.product_categories').find('.hide').removeClass('hide');  
        $(this).html('Show Less');
      }else{
        $('.product_categories').find('.show').addClass('hide');
        $('.product_categories').find('.show').removeClass('show');  
        $(this).html('Show More');
      }
      
      return false;
    });

    $('footer .widget-title').on('click',function(){
      if($(this).attr('class')==='widget-title w_close'){
        $(this).toggleClass('w_close w_open');
      }else{
        $(this).toggleClass('w_close w_open');
      }
      $(this).parent().next().toggle('slow');
    });


    $('.gnc_social_share_btn').on('click',function(e){
      $('.gnc_social_share__container').toggle();
      e.stopPropagation();
    });

    $('body').on('click',function(){
      if($('.gnc_social_share__container').is(':visible')){
          $('.gnc_social_share__container').hide();
          console.log('visible')
      }else{
        console.log('hidden');
      }
      
    });
});
// $('.promo-items').slick({
// autoplay: true,
//   autoplaySpeed: 2000,
//   dots: true,
//   infinite: true,
//   fade: true,
//   cssEase: 'linear',
//   adaptiveHeight: true,
  
  
  
// });


// $('.slick-inner').slick({
// autoplay: true,
//   autoplaySpeed: 2000,
//   dots: true,
//   infinite: true,
//   fade: true,
//   cssEase: 'linear',
//   adaptiveHeight: true,
// });


             
//       $('#coupon_code').val('SUM2020');
      
//             //keep submit button initially disabled
//            $('#prod_search_submit').prop('disabled', 'disabled');
 
//           $('#prod_search input').on('blur keyup', function() {
//            console.log('search box input');
//            if ($('#prod_search').valid()) {
//              $('#prod_search_submit').prop('disabled', false);  
//            } else {
//              $('#prod_search_submit').prop('disabled', 'disabled');
//            }
       
       
//          });
         
//               $(function() {
       
//              $('#prod_search').validate({
//         rules:{
//           s:{
//             required:true,
            
             
            
//           },
          
//         },
//         messages:{
//           s:{
//             required:'',
            
            
//           },					 
          
//         },
//        });
            


// });

// $('#btn-collapse-menu').on('click',function(){
// $('#overlay_background').show();
// });
// $('#overlay_background').on('click',function(){
// $('#bs-main-navbar-collapse-1').removeClass('show');
// $(this).hide();
// });
// $('#bs-main-navbar-collapse-1').on('show.bs.collapse', function () {
// // do something…


// });

// $('#bs-main-navbar-collapse-1').on('hidden.bs.collapse', function () {
// // do something…

// });

// });

if(jQuery('body').hasClass('single-product')){
	//var templateUrl = object_name.templateUrl;
	jQuery('.single_variation_wrap .woocommerce-variation-price').css('display', 'none');
	//var oldp = jQuery('.single-product div.product-type-variable p.price').html();
	jQuery('table.variations select').change(function() {
		//var sortBy = 0;		
		//var pid  = jQuery('div.product').attr('rel');
		//alert(pid);
		setTimeout(function(){
			jQuery('.single_variation_wrap .woocommerce-variation-price').css('display', 'none');
		jQuery('.single-product div.product-type-variable p.price').html(jQuery('.single_variation_wrap span.price').html());
		//alert(templateUrl);
		
		//var sortBy = jQuery('input[name="variation_id"]').val();
    //let url=templateUrl+'/inc/getSku.php?varid='+sortBy+'&prodcutid='+pid;
    //let url='/inc/getSku.php?varid='+sortBy+'&prodcutid='+pid;

		
		
		
		}, 1000)
		
	})
}

//Bootstrap 4.*
$(function () {
  $('[data-toggle="popover"]').popover({trigger:'hover'})
})



// WEBPACK FOOTER //
// resources/assets/scripts/main.js